import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/rating_dashboard`, {params: {...filter}})
  },

}
